import { Box, Button } from "@mui/joy";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";

export default function CTA({ dark }: { dark: boolean }) {
  return (
    <Box
      sx={[
        (theme) => ({
          py: 14,
          px: {
            xs: 0,
            md: 8,
            lg: 14
          },
          background: dark
            ? `linear-gradient(to right, #4c1d95, #1e3a8a)`
            : `linear-gradient(to right, #8b5cf6, #38BDF8)`,
        }),
      ]}
    >
      <div className="container px-4 md:px-6 mx-auto space-y-6">
        <div className="flex flex-col items-center space-y-4 text-center">
          <h2 className="text-5xl font-bold tracking-normal sm:text-4xl md:text-5xl text-center text-white">
            Ready to Hack The Way?
          </h2>
          <p className="mx-auto max-w-[700px] md:text-xl text-white">
            Join our platform today and start your journey in the exciting world
            of IT, IoT, and OT security.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              className="bg-white text-[#7B3FE4] hover:bg-gray-100"
              variant="solid"
              onClick={() => {
                window.location.href = "/signup";
              }}
            >
              Sign Up Now
            </Button>
            <Button
              size="lg"
              variant="outlined"
              className="text-white border-white hover:bg-white/20"
              onClick={() => {
                window.location.href = "/aboutus";
              }}
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </Box>
  );
}
